// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2505":"164f4fb6","3632":"b645e135","7337":"ad2866b8","8445":"bc98253f"}[chunkId] || chunkId) + "." + {"1411":"1f98ddc80c7a1213","2505":"ef4659a338c7ec17","3553":"0297fc07a7884341","3632":"9f121a1c57da8c9c","3969":"e0b23354d7428ae6","7337":"6ec81e1682b2dbc1","8445":"c64048ead8d40619"}[chunkId] + ".js";
};